import Box from '@mui/material/Box';
import Grid from '@mui/material/GridLegacy';
import Typography from '@mui/material/Typography';

interface PropTypes {
  children: JSX.Element | JSX.Element[];
}

function TeamContainer(props: PropTypes): JSX.Element {
  return (
    <Box>
      <Box marginBottom={4}>
        <Typography fontWeight={700} variant={'h4'} align={'center'}>
          Our Team
        </Typography>
      </Box>
      <Grid container spacing={2}>
        {props.children}
      </Grid>
    </Box>
  );
}

export default TeamContainer;
